import { DefaultValues } from 'react-hook-form';
import { z } from 'zod';

import { erasmusTypeList } from '@/module/Travel/Request/model/TravelRequestTypes';

import { Mobility, MobilityRequest } from './MobilityTypes';

export const mobilitySchema = z
  .object({
    type: z.enum(erasmusTypeList).nullable(),
    startDate: z.string(),
    endDate: z.string(),
  })
  .superRefine((values, ctx) => {
    if (values.type == null) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['type'], params: { i18n: 'custom.required' } });
    }
  })
  .refine(values => new Date(values.endDate) >= new Date(values.startDate), {
    path: ['endDate'],
    params: { i18n: 'custom.mobilityEndBeforeStart' },
  });

export type MobilitySchema = z.infer<typeof mobilitySchema>;

export const defaultMobilityValues: DefaultValues<MobilitySchema> = {
  type: null,
};

export function toMobilitySchema(mobility: Mobility): MobilitySchema {
  return {
    type: mobility.type,
    startDate: mobility.startDate,
    endDate: mobility.endDate,
  };
}

export function toMobilityRequest(values: MobilitySchema): MobilityRequest {
  if (values.type == null) {
    throw new Error('a mobility cannot be saved without a type');
  }

  return {
    type: values.type,
    startDate: values.startDate,
    endDate: values.endDate,
  };
}
